import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ScrutinyPopupComponent } from '../scrutiny-popup/scrutiny-popup.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-student-history',
  templateUrl: './student-history.component.html',
  styleUrls: ['./student-history.component.scss']
})
export class StudentHistoryComponent implements OnInit {
  // datePipe: DatePipe = new DatePipe('en-US');
  SctHist: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  APIService: any;
  ScrutinyTable: [];
  StudentId = 0;
  dialogRef: MatDialogRef<any>;
  date: any;
  time: any;
  sctLvl = 0;
  scrutinyStatusArray: any;
  sessionId = 0;
  CoCode = 0;
  CgCode = 0;
  scrutiny: string;
  // jsonData: any;
  constructor(private dialog: MatDialog,
    public umsService: UmsService,
    public dialogRef1: MatDialogRef<StudentHistoryComponent>,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private spinner: NgxSpinnerService,private route: ActivatedRoute,
    private datePipe: DatePipe,@Inject(MAT_DIALOG_DATA) public data: any,
  ) { this.APIService = environment.serviceUrl; }
 
  // convertUTCToIST(dateString: string): string {
  //   const utcDate = new Date(dateString); // Convert string to Date object
  //   const istDate = new Date(utcDate.getTime() - (330 * 60 * 1000)); // IST is UTC + 5:30
  //   return this.datePipe.transform(istDate, 'dd/MM/yyyy h:mm:ss a', 'Asia/Kolkata') || '';
  // }

  ngOnInit(): void {
   this.StudentId = this.data['StudentId']
    this.submitButton = true;
    this.editButton = false;
    this.SctHist = this.fb.group({

    });
    this.getData();
  }

  
  
  getData() {
    const payload = {};
    payload['UserId'] = sessionStorage.getItem('userId');
    payload['StudentId'] = this.StudentId;
    this.umsService.fetchScrutinyHistory(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        this.ScrutinyTable = res.data;
        this.scrutinyStatusArray = res.data;
      } else {
        if(res.message == 'No Data Found'){
          this.ScrutinyTable = [];
        }
      }
    });
  }


  close() {
    this.dialogRef1.close();
  }

  getLoginFullName(studentId: number, status: string): string {
    if (status === 'Submitted' || status === 'ReSubmitted') {
        return 'Student';
    } else {
        const matchingScrutiny = this.scrutinyStatusArray.find(scrutiny => scrutiny.StudentId == studentId);
        return matchingScrutiny ? matchingScrutiny.LoginName : '';
        
    }
}

convertUTCToIST(dateString: string): string {
  const utcDate = new Date(dateString); // Convert string to Date object
  // Directly use the date pipe with 'Asia/Kolkata' time zone
  return this.datePipe.transform(utcDate, 'dd/MM/yyyy h:mm:ss a', 'Asia/Kolkata') || '';
}
}
